<template>
  <div
    class="d-flex justify-content-center align-items-center"
    id="main-content"
  >
    <BlockUI v-if="loading">
      <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
    </BlockUI>

    <div class="text-center d-none d-md-block">
      <img src="@/assets/images/brand/logo.svg" alt="Logo Urbnx" id="logo" />
      <h1 v-html="$t('login.verify-email.leave-the-stress-out-br')"></h1>
      <img src="@/assets/images/brand/welcome.png" id="welcome-img" />
    </div>

    <div class="text-center d-block d-md-none">
      <div>
        <img src="@/assets/images/brand/logo.svg" alt="Logo Urbnx" id="logo" />
      </div>
      <div>
        <img src="@/assets/images/brand/welcome-mobile.png" id="welcome-img" />
      </div>
      <h1>{{ $t("login.verify-email.leave-the-stress-out") }}</h1>
    </div>

    <MessageBanner
      :message="error"
      :type="'error'"
      :classes="['position-bottom-center']"
      v-if="error !== ''"
    />
  </div>
</template>

<script>
import MeService from "@/services/me";

export default {
  data() {
    return {
      error: "",
      loading: false
    };
  },
  methods: {
    async verifyEmail() {
      const code = this.$route.query.oobCode;

      this.loading = true;
      this.error = "";

      try {
        await MeService.verifyEmail(code);

        location.href = "/login";
      } catch (error) {
        this.error = this.$t("dashboard.public.resetpage.message-error");
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.verifyEmail();
  },
  beforeMount() {
    const code = this.$route.query.oobCode;

    if (!code) {
      location.href = "/";
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk&display=swap");

#main-content {
  height: 100vh;
  background: url("./../../assets/images/brand/background.svg") no-repeat;
  background-position: center;
  background-size: cover;

  @media (max-width: 768px) {
    background: url("./../../assets/images/brand/background-mobile.svg")
      no-repeat;
    background-position: center;
    background-size: cover;
  }

  #logo {
    width: 193px;
  }

  h1 {
    margin-top: 56px;
    font-family: "Space Grotesk", sans-serif;
    font-weight: bold;
    color: #ccb5ff;
    font-size: 96px;

    @media (max-width: 768px) {
      font-size: 56px;
    }
  }

  #welcome-img {
    width: 583px;
    margin-top: 71px;

    @media (max-width: 768px) {
      margin-top: 58px;
      width: 133px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/public/VerifyEmailPage.vue